// RFC 4122 UUIDs via the platform. The legacy hand-rolled generator produced
// random base62 strings that failed every z.string().uuid() check (Notify
// schema, removeNotify), causing error-notification loops. The parameter is
// dead weight kept so the ~380 existing uuid('v4') call sites keep compiling
// without a mass rename.
export const uuid = (_type: 'v4' = 'v4'): string => {
  return crypto.randomUUID()
}
